import React from "react";

import SalesforceImg from "images/datasource-sf.png";
import MicrosoftImg from "images/microsoft.png";
import SAPImg from "images/sap.png";
import MarketoImg from "images/marketo.png";
import OracleImg from "images/oracle.png";

import { SolutionVendor } from "containers/Recipe/reducer";

import styles from "./style.module.css";

export default class TraySolutionVendorImage extends React.PureComponent {
  getImage(vendor) {
    switch (vendor) {
      case SolutionVendor.Microsoft:
        return MicrosoftImg;

      case SolutionVendor.Salesforce:
        return SalesforceImg;

      case SolutionVendor.SAP:
        return SAPImg;

      case SolutionVendor.Marketo:
        return MarketoImg;

      case SolutionVendor.Oracle:
        return OracleImg;

      default:
        return undefined;
    }
  }

  render() {
    const { vendor } = this.props;

    const image = this.getImage(vendor);

    return image ? <img style={this.props.style} className={styles.recipeImg} src={image} /> : <React.Fragment />;
  }
}
